module.exports = __webpack_public_path__ + "img/icon_Edit.bc505fed.svg";